import cx from 'clsx';
import { format } from 'date-fns';
import { Avatar } from 'src/components/user/avatar.component';
import { formatOldBlogPostDates } from 'src/utils/format';
import type { BlogPage } from '../../types/blogPage';
import { Stack, Type } from '../core';

export interface DocumentMetadataProps {
  className?: string;
  containerClassName?: string;
  document: BlogPage;

  /**
   * @default 'medium'
   */
  size?: 'small' | 'medium';
}

export function DocumentMetadata({
  className,
  containerClassName,
  document,
  size = 'medium',
}: DocumentMetadataProps) {
  return (
    <Stack component="h3" gap="space-x-2" className={containerClassName}>
      <Avatar user={document?.attributes} size="xsmall" />
      <Type
        colorVariant="faded"
        className={cx('text-center flex items-center space-x-2', className)}
        variant={size === 'small' ? 'text-sm' : 'text-base'}
      >
        {formatOldBlogPostDates(
          [
            document?.attributes?.author,
            format(new Date(document?.attributes?.publishedAt), 'LLLL d, yyyy'),
          ].join(' · '),
          document?.id,
          document?.attributes?.author
        )}
      </Type>
    </Stack>
  );
}
